import React from 'react'
import style from './SearchInput.module.css'
interface Props {
  value: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export default function SearchInput({ onChange, value }: Props) {
  const renderIcon = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3287 17.743C14.6048 19.1537 12.4012 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 12.4013 19.1536 14.605 17.7428 16.3289L23.9999 22.5859L22.5858 24L16.3287 17.743ZM18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10Z"
        fill="#AAAAAA"
      />
    </svg>
  )
  return (
    <div className={style.root}>
      {renderIcon()}
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder="Search"
        className={style.input}
      />
    </div>
  )
}
